import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import adminApi from "../lib/adminApi";
import { isEmbedded } from "../lib/shopifyAdmin";

// Red banner shown across the admin area the moment the spend gate pauses, so a pause is never silent.
export function SpendGateBanner() {
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    if (!isEmbedded()) return;
    let alive = true;
    adminApi
      .get("/spend-gate")
      .then(({ data }) => {
        const a = data?.gate?.alert;
        if (alive && a && !a.acked) setAlert({ ...a, paused: data.gate.paused });
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (!alert) return null;
  return (
    <div data-testid="spend-gate-banner" className="rounded-2xl border border-rose-300 bg-rose-50 text-rose-900 px-4 py-3 flex items-start gap-3">
      <AlertTriangle className="h-5 w-5 shrink-0 mt-0.5" />
      <div className="flex-1 text-sm">
        <p className="font-bold">Paid AI work is paused — customer ducks are parked, not failed</p>
        <p className="mt-1">{alert.reason}</p>
      </div>
      <Link to="/shop-app/spend-gate" data-testid="spend-gate-banner-link" className="text-sm font-semibold underline shrink-0">
        Open spend gate
      </Link>
    </div>
  );
}
